import { render, staticRenderFns } from "./adminStaffDetail.vue?vue&type=template&id=77ea64dc&scoped=true"
import script from "./adminStaffDetail.vue?vue&type=script&lang=js"
export * from "./adminStaffDetail.vue?vue&type=script&lang=js"
import style0 from "./adminStaffDetail.vue?vue&type=style&index=0&id=77ea64dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea64dc",
  null
  
)

export default component.exports